import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdateBusinessCardsRequestSchema,
  TUpdateBusinessCardsResponseSchema,
} from "./updateBusinessCards.schema";

export const updateBusinessCards = (axios: IAxiosInstance) => {
  return async (body: TUpdateBusinessCardsRequestSchema) => {
    const response = await axios.noRetry.patch<
      IApiResponse<TUpdateBusinessCardsResponseSchema>
    >(`/api/business-cards`, body);

    return response.data;
  };
};
